var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex align-items-baseline"},[_c('span',{staticClass:"material-icons md-12 me-1"},[_vm._v("radio_button_checked")]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.content))])])}
var staticRenderFns = []

export { render, staticRenderFns }